export default{
    usTitle:"Hubungi Kami",
    usH4:"Semoga Bisa Segera Bekerja Sama",
    usSpan:"Silahkan Mengisi Informasi Anda, Kami Akan Segera Menghubungi Anda",
    first:'Nama',
    last: '姓氏',
    email:"Email",
    phone:"Nomor Telepon",
    company:"Nama Perusahaan",
    message:"Isi Pesan",
    country:"国家/地区",
    state:"Provinsi",
    city:"Kota",
    submit:"Kirimkan",
    h4:"Selamat Datang",
    p1:"Alamat Kantor：",
    p2:"亚洲，新加坡：",
    hint:"必填项",
    emailHint:"格式错误",
    dialogTitle:'Dikirim',
    dislogP:'Kami akan menghubungimu secepat mungkin',

}